import { Container } from "@mui/material";
import DateSort from "./Components/PortfolioCard/Components/DateSort";
import { PORTFOLIO_TYPES } from "./Components/constants";
import PortfolioCard from "./Components/PortfolioCard";
import PortfolioInvestmentTable from "./Components/PortfolioInvestmentTable";
import PortfolioTradeTable from "./Components/PortfolioTradeTable";
import PortfolioTypeTabs from "./Components/PortfolioTypeTabs";
import { useSearchParams } from "react-router-dom";

function Portfolio() {
  const [searchParams] = useSearchParams();
  const portfolioType = +searchParams.get("portfolioType") || 0;

  return (
    <Container maxWidth="100%">
      {portfolioType === PORTFOLIO_TYPES.trade.key && <PortfolioCard />}

      <DateSort />

      <PortfolioTypeTabs />

      {portfolioType === PORTFOLIO_TYPES.trade.key && <PortfolioTradeTable />}
      {portfolioType === PORTFOLIO_TYPES.investment.key && (
        <PortfolioInvestmentTable />
      )}
    </Container>
  );
}

export default Portfolio;
